"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var queryString = require("query-string");
var Routes_1 = require("../../../../../common/enum/Routes");
var usePlatformConfig_1 = require("../../../../../common/react/usePlatformConfig");
var collectedFilters_1 = require("../../../../../common/service/collectedFilters");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var ContinueButton_1 = require("../../../../common/components/continueButton/ContinueButton");
var errorHandler_1 = require("../../../../common/service/errorHandler");
var useCheckoutContext_1 = require("../../../../common/hooks/useCheckoutContext");
var useSaveExpressionsOfInterest_1 = require("../../../../commonSteps/extras/hooks/mutations/useSaveExpressionsOfInterest");
var ExtrasContinueButton = function (_a) {
    var dealExpressionsOfInterest = _a.dealExpressionsOfInterest;
    var history = react_router_dom_1.useHistory();
    var isDealerEnabled = usePlatformConfig_1.default().platformConfig.platformFeatures.isDealerEnabled;
    var _b = collectedFilters_1.default().filters, token = _b.token, expressionsOfInterest = _b.expressionsOfInterest;
    var saveExpressionsOfInterest = useSaveExpressionsOfInterest_1.useSaveExpressionsOfInterest().saveExpressionsOfInterest;
    var refetch = useCheckoutContext_1.default().refetch;
    var handleClick = react_1.useCallback(function () {
        var _a;
        if (dealExpressionsOfInterest.toString() !== expressionsOfInterest) {
            var codes = (_a = expressionsOfInterest) === null || _a === void 0 ? void 0 : _a.split(',');
            saveExpressionsOfInterest(token, codes)
                .then(function () {
                refetch && refetch();
            })
                .catch(function (error) {
                errorHandler_1.default.handleError(error);
            });
        }
        var searchParams = queryString.stringify({ token: token, expressionsOfInterest: expressionsOfInterest }, { arrayFormat: 'comma' });
        history.push({
            pathname: isDealerEnabled ? Routes_1.Routes.DEALER : Routes_1.Routes.REQUEST_QUOTE,
            search: searchParams,
        });
    }, [history, token, isDealerEnabled, expressionsOfInterest, dealExpressionsOfInterest]);
    return (<ContinueButton_1.default onClick={handleClick} testId={'checkout:extras:continue:button'}>
      <Translation_1.default id={'trans__checkout__extras_page__continue_cta'}/>
    </ContinueButton_1.default>);
};
exports.default = ExtrasContinueButton;
